import React from 'react'
import { Link } from 'react-router-dom'
export default function BlogCards({cardData}) {
  return (
 
      <div class="xl:w-1/4 md:w-1/2 p-4">
        <div class="bg-gray-800 bg-opacity-40 p-6 rounded-lg">
        <Link to={`/blog/${cardData.id}`}>
          <img class="h-40 rounded w-full object-cover object-center mb-6" src={`${cardData.image}`} alt="content"/>
          <h3 class="tracking-widest text-indigo-400 text-xs font-medium title-font invisible">SUBTITLE</h3>
          <h2 class="text-lg text-white font-medium title-font mb-4">{cardData.title}</h2>
          <div className='h-24 overflow-hidden'>
            
          <p class="leading-relaxed text-base">{cardData.subTitle}</p>
          
          </div>
          </Link>
        </div>
      </div>
      
  )
}
